// Single-fetch cache for /api/options. The universe of valid guesses
// rarely changes during a play session, so we fetch once per page load
// and hand the same arrays to every ComboBox.

import { useEffect, useState } from 'react'

export type Options = { movies: string[]; actors: string[] }

let cache: Options | null = null
let pending: Promise<Options> | null = null

async function fetchOptions(): Promise<Options> {
  if (cache) return cache
  if (!pending) {
    pending = fetch('/api/options')
      .then((r) => r.json() as Promise<Options>)
      .then((data) => {
        cache = data
        pending = null
        return data
      })
      .catch((err) => {
        pending = null
        throw err
      })
  }
  return pending
}

export function useOptions(): Options | null {
  const [opts, setOpts] = useState<Options | null>(cache)
  useEffect(() => {
    if (cache) {
      if (!opts) setOpts(cache)
      return
    }
    let cancelled = false
    fetchOptions().then((data) => {
      if (!cancelled) setOpts(data)
    }).catch(() => { /* swallow — combobox will degrade to typing */ })
    return () => { cancelled = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return opts
}
